import React, { useState, useEffect } from "react";
import StyledDrawer from "../StyledDrawer";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  makeStyles,
  Divider,
  IconButton
} from "@material-ui/core";
import {
  Link as RouterLink,
  Route,
  Redirect,
  Switch,
  useLocation
} from "react-router-dom";
import APITab from "./APITab";
import WebhooksTab from "./WebhooksTab";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(theme => ({
  accountHeader: {
    boxSizing: "border-box"
  },
  tabsWrapper: {
    padding: theme.spacing(0, 1),
    marginBottom: -1,
    marginTop: theme.spacing(3),
    minHeight: theme.spacing(5)
  },
  tabItem: {
    minWidth: "0",
    textTransform: "none",
    fontSize: "0.875rem",
    padding: theme.spacing(1, 0, 1.75),
    margin: theme.spacing(0, 2),
    lineHeight: "1rem",
    minHeight: theme.spacing(5),
    color: theme.palette.secondary.main
  },
  primary: {
    color: theme.palette.text.primary + "!important"
  },
  title: {
    fontSize: "1.25rem",
    lineHeight: "1.4375rem",
    fontWeight: 500
  },
  iconButton: {
    marginLeft: "-0.5rem",
    marginRight: theme.spacing(2),
    "& svg": {
      width: theme.spacing(3),
      height: theme.spacing(3)
    }
  },
  divider: {
    backgroundColor: "#DDD"
  }
}));

export default function DevelopersDialog({
  open,
  handleClose,
  saveDisabled,
  drawerExpanded
}) {
  const classes = useStyles();

  const [value, setValue] = useState(0);

  // Tab change
  const handleChange = (event, newValue) => {
    if (newValue !== value) {
      if (saveDisabled) {
        setValue(newValue);
      }
    }
  };

  useEffect(() => {
    return setValue(0);
  }, []);

  const location = useLocation();

  const [loading, setLoading] = useState(false);

  return (
    <StyledDrawer open={open} handleClose={handleClose} loading={loading}>
      <Box
        className={classes.accountHeader}
        display="flex"
        justifyContent="space-between"
        px={3}
        py={2.5}
      >
        <Box alignSelf="center" alignItems="center" display="flex" pr={2}>
          <IconButton
            onClick={() => handleClose()}
            className={classes.iconButton}
          >
            <CloseIcon />
          </IconButton>
          <Typography className={classes.title} variant="h5">
            Developers
          </Typography>
        </Box>
      </Box>

      <Tabs
        value={location.pathname}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        className={classes.tabsWrapper}
      >
        <Tab
          label="API Keys"
          component={RouterLink}
          to="/developers/api-keys"
          value="/developers/api-keys"
          classes={{ root: classes.tabItem, selected: classes.primary }}
        />
        <Tab
          label="Webhooks"
          component={RouterLink}
          to="/developers/webhooks"
          data-cy="webhooks"
          value="/developers/webhooks"
          classes={{ root: classes.tabItem, selected: classes.primary }}
        />
      </Tabs>
      <Divider className={classes.divider} />
      <Box pl={3} pr={5} flexGrow="1" flexShrink="1" overflow="auto">
        <Switch>
          <Route path="/developers/api-keys">
            <APITab value={value} index={0} />
          </Route>
          <Route path="/developers/webhooks">
            <WebhooksTab
              value={value}
              index={1}
              drawerExpanded={drawerExpanded}
              setLoading={setLoading}
            />
          </Route>
          <Redirect to="/developers/api-keys" />
        </Switch>
      </Box>
    </StyledDrawer>
  );
}
